
// export const BASE_URL = 'https://api.tronweb.cc/tronpay/' 
// export const BASE_URL = "https://api.tgboty.top/hwuu/"
// 根据当前域名自动判断环境 珩旺的
// export const BASE_URL = (() => {
//   const hostname = window.location.hostname;
  

//     // 开发环境或本地环境，可以根据需要设置默认值
//     return 'https://'+ hostname +'/hwuu/'; // 或者本地开发环境地址

// })();



// baby的
// babyuu
// export const BASE_URL = (() => {
//   const hostname = window.location.hostname;
  

//     // 开发环境或本地环境，可以根据需要设置默认值
//     return 'https://'+ hostname +'/babyuu/'; // 或者本地开发环境地址

// })();

// baby的
// babyuu
// export const BASE_URL = (() => {
//   const hostname = window.location.hostname;
  

//     // 开发环境或本地环境，可以根据需要设置默认值
//     return 'https://'+ hostname +'/babyuu/'; // 或者本地开发环境地址

// })();

export const BASE_URL ='https://api.tgboty.top/daoyd/'